import { create } from "zustand";
import { PartComponent, PartName, SelectingPart } from "@/types/design";
import { INITIAL_PART_NAME } from "@/const/initialPartStyle";

type PartState = {
	parts: Record<PartName, PartComponent[]>;
	setParts: (category: PartName, items: PartComponent[]) => void;
};

export const partsStore = create<PartState>((set) => ({
	parts: {
		hair: [],
		backHair: [],
		eyebrows: [],
		eyeline: [],
		eyes: [],
		mouth: [],
	},
	setParts: (category, items) =>
		set((state) => ({
			parts: {
				...state.parts,
				[category]: items,
			},
		})),
}));

type SelectingPartState = {
	selectingPart: SelectingPart;
	setSelectingPart: (initialSelectingPart: SelectingPart) => void;
	updateSelectingPart: (updatedSelectingPart: SelectingPart) => void;
	resetSelectingPart: () => void;
};

export const selectingPartStore = create<SelectingPartState>((set) => ({
	selectingPart: {
		partId: undefined,
		partName: "hair",
	},
	setSelectingPart: (initialSelectingPart: SelectingPart) =>
		set({ selectingPart: initialSelectingPart }),
	updateSelectingPart: (updatedSelectingPart: SelectingPart) =>
		set({ selectingPart: updatedSelectingPart }),
	resetSelectingPart: () =>
		set({
			selectingPart: { partName: INITIAL_PART_NAME, partId: undefined },
		}),
}));
